<template>
    <v-container>
        <v-row>
            <v-col cols="4">
                <v-select v-model="selectedAthleteId" :items="athletes" label="Select an Athlete" outlined></v-select>

                <div class="text-center" style="width: 100%">
                    <scorsync-avatar
                        v-if="selectedAthleteId"
                        :person="selectedAthlete"
                        size="lg"
                        class="mx-auto text-center"
                    />
                </div>

                <avatar-changer
                    v-if="selectedAthleteId && user"
                    :entity-id="selectedAthleteId"
                    :current="selectedAthlete.profile_photo_path"
                    model="athlete"
                    no-submit
                    @input="updateAthlete"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Club from '@/Models/Club.js';
import AvatarChanger from '@/Components/AvatarChanger.vue';
import User from '@/Models/User.js';
import ScorsyncAvatar from '@/Components/ScorsyncAvatar.vue';
import Athlete from '@/Models/Athlete.js';

export default {
    name: 'ClubAthletePhotos',

    components: { ScorsyncAvatar, AvatarChanger },

    props: {
        club: {
            type: Club,
            required: true,
        },
    },

    data: () => ({
        selectedAthleteId: null,
    }),

    computed: {
        user() {
            if (!this.$page.props.auth.user) {
                return null;
            }

            return User.query().with('affiliations').find(this.$page.props.auth.user.id);
        },

        selectedAthlete() {
            return _.first(this.club.athletes.filter(athlete => this.selectedAthleteId === athlete.id));
        },

        athletes() {
            return _.sortBy(this.club.athletes, 'name').map(athlete => ({ text: athlete.name, value: athlete.id }));
        },
    },

    methods: {
        async updateAthlete(blob) {
            const formData = new FormData();

            formData.append('_method', 'put');
            formData.append('avatar', blob, 'avatar.png');
            formData.append('model', 'athlete');

            await Athlete.put(`/api/avatar/${this.selectedAthleteId}`, formData);
        },
    },
};
</script>
